import { Platform, StatusBar } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { rem } from 'design-system';
import Phone from './dimensions';
import { deviceHasDynamicIsland } from '../constants';
const errorStatusBarHeight = (top) => {
    if (Platform.OS === 'ios' && Platform.isPad) {
        return top + rem(12);
    }
    if (Phone.isIphoneX()) {
        if (deviceHasDynamicIsland) {
            return top + rem(5);
        }
        return top + rem(8);
    }
    if (Platform.OS === 'android')
        return (StatusBar.currentHeight || top) + rem(14);
    if (Platform.OS === 'web') {
        return 48;
    }
    return 32;
};
export const useErrorStatusbarHeight = () => {
    const { top } = useSafeAreaInsets();
    return errorStatusBarHeight(top);
};
